import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronTop"><Path fillRule="evenodd" clipRule="evenodd" d="M13.0606 8.76771C12.4749 8.18192 11.5251 8.18192 10.9393 8.76771L4.35355 15.3535C4.15829 15.5488 3.84171 15.5488 3.64645 15.3535C3.45118 15.1582 3.45118 14.8417 3.64645 14.6464L10.2322 8.0606C11.2085 7.08429 12.7914 7.08429 13.7677 8.0606L20.3536 14.6464C20.5488 14.8417 20.5488 15.1582 20.3536 15.3535C20.1583 15.5488 19.8417 15.5488 19.6464 15.3535L13.0606 8.76771Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTop;
